import { render } from "./HistoryMemoView.vue?vue&type=template&id=ada88a12"
import script from "./HistoryMemoView.vue?vue&type=script&lang=js"
export * from "./HistoryMemoView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__